import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import useInventoryManagement from "./hooks/useInventoryManagement";
import { useEffect } from "react";
import Spinner from "../../Components/spinner/spinner";


const AddVendor = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const {
        handleVendorChange,
        setTab,
        spinner,
        vendorFormData,
        stateList,
        countryList,
        vendorFormik,
    } = useInventoryManagement()


    useEffect(() => {
        if (location.state?.tab) {
            setTab(location.state.tab);
        }
    }, [location, setTab]);

    const approvalStatus = [
        { value: 'Pending', label: 'Pending' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Rejected', label: 'Rejected' }
    ]


    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner ? <Spinner /> : null}
                <header>
                    <h2 className='page-tittle'><i className="fa-solid fa-angle-left cusgap cursor" onClick={() => { navigate(-1) }}></i>Add Vendor</h2>
                    <hr />
                </header>
                <form onSubmit={vendorFormik.handleSubmit} className="row ps-4 cus-form mt-4">
                    <div class=" py-3 mb-3 rounded row">

                        <div className="col-md-6">
                            <div className="mb-1">
                                <label className="form-label">Vendor/Company Name *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.name} type="text" name="name" className={`form-control alreadytext ${vendorFormik.touched.name && vendorFormik.errors.name ? 'is-invalid' : ''}`} />
                                {vendorFormik.touched.name && vendorFormik.errors.name && (
                                    <div className="invalid-feedback">{vendorFormik.errors.name}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <label className="form-label">Category *</label>
                            <input onChange={handleVendorChange} value={vendorFormData.category} type="text" name="category" className={`form-control alreadytext ${vendorFormik.touched.category && vendorFormik.errors.category ? 'is-invalid' : ''}`} />
                            {vendorFormik.touched.category && vendorFormik.errors.category && (
                                <div className="invalid-feedback">{vendorFormik.errors.category}</div>
                            )}
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Phone Number * </label>
                                <input maxLength={10} onChange={handleVendorChange} value={vendorFormData.phoneNumber} name="phoneNumber" type="number" className={`form-control alreadytext ${vendorFormik.touched.phoneNumber && vendorFormik.errors.phoneNumber ? 'is-invalid' : ''}`} />
                                {vendorFormik.touched.phoneNumber && vendorFormik.errors.phoneNumber && (
                                    <div className="invalid-feedback">{vendorFormik.errors.phoneNumber}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Email</label>
                                <input onChange={handleVendorChange} value={vendorFormData.email}
                                    name="email"
                                    type="text"
                                    className="form-control alreadytext"


                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Street Address</label>
                                <input onChange={handleVendorChange} value={vendorFormData.street} name="street" type="text" className="form-control alreadytext" />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">City</label>
                                <input onChange={handleVendorChange} value={vendorFormData.city}
                                    name="city"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Country *</label>

                                <select className={`form-select form-control ${vendorFormik.touched.country && vendorFormik.errors.country ? 'is-invalid' : ''}`} aria-label="Default select example" name="country" onChange={(e) => handleVendorChange(e, 'COUNTRY')} value={vendorFormData.country}>
                                    <option value='' hidden>Select country</option>
                                    {countryList.map((item) => (
                                        <option value={item._id} key={item._id}
                                        >{item?.name}</option>
                                    ))}
                                </select>
                                {vendorFormik.touched.country && vendorFormik.errors.country && (
                                    <div className="invalid-feedback">{vendorFormik.errors.country}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">GSTIN *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.GSTIN}
                                    name="GSTIN"
                                    type="text"

                                    className={`form-control alreadytext ${vendorFormik.touched.GSTIN && vendorFormik.errors.GSTIN ? 'is-invalid' : ''}`}
                                />
                                {vendorFormik.touched.GSTIN && vendorFormik.errors.GSTIN && (
                                    <div className="invalid-feedback">{vendorFormik.errors.GSTIN}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">State/Province</label>
                                <select className="form-select form-control" aria-label="Default select example" name="state" onChange={handleVendorChange} value={vendorFormData.state}>
                                    <option value='' hidden>Select state</option>
                                    {stateList.map((item) => (

                                        <option value={item._id} key={item._id}>{item?.name}</option>
                                    ))}

                                </select>
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Postal Code</label>
                                <input onChange={handleVendorChange} value={vendorFormData.postalCode}
                                    name="postalCode"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">PAN *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.PAN}
                                    name='PAN'
                                    type="text"
                                    className={`form-control alreadytext ${vendorFormik.touched.PAN && vendorFormik.errors.PAN ? 'is-invalid' : ''}`}
                                />
                                {vendorFormik.touched.PAN && vendorFormik.errors.PAN && (
                                    <div className="invalid-feedback">{vendorFormik.errors.PAN}</div>
                                )}
                            </div>
                        </div>
                        {/* <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Bank Details</label>
                                <input onChange={handleVendorChange} value={vendorFormData.bankDetails}
                                    name="bankDetails"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div> */}
                        {/* Bank Details Fields */}
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Bank Name *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.bankName}
                                    name="bankName"
                                    type="text"
                                     className={`form-control alreadytext ${vendorFormik.touched.bankName && vendorFormik.errors.bankName ? 'is-invalid' : ''}`}
                                />
                                {vendorFormik.touched.bankName && vendorFormik.errors.bankName && (
                                    <div className="invalid-feedback">{vendorFormik.errors.bankName}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Account Number *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.accountNumber}
                                    name="accountNumber"
                                    type="text"
                                   className={`form-control alreadytext ${vendorFormik.touched.accountNumber && vendorFormik.errors.accountNumber ? 'is-invalid' : ''}`}

                                />
                                {vendorFormik.touched.accountNumber && vendorFormik.errors.accountNumber && (
                                  <div className="invalid-feedback">{vendorFormik.errors.accountNumber}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">IFSC/SWIFT Code *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.ifscSwiftCode}
                                    name="ifscSwiftCode"
                                    type="text"
                                    className={`form-control alreadytext ${vendorFormik.touched.ifscSwiftCode && vendorFormik.errors.ifscSwiftCode ? 'is-invalid' : ''}`}
                                />
                                {vendorFormik.touched.ifscSwiftCode && vendorFormik.errors.ifscSwiftCode && (
                                  <div className="invalid-feedback">{vendorFormik.errors.ifscSwiftCode}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Payment Terms</label>
                                <input onChange={handleVendorChange} value={vendorFormData.PaymentTerms}
                                    name="PaymentTerms"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Credit Limit</label>
                                <input onChange={handleVendorChange} value={vendorFormData.creditLimit}
                                    name="creditLimit"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Lead Time</label>
                                <input onChange={handleVendorChange} value={vendorFormData.leadTime}
                                    name="leadTime"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Rating/Score *</label>
                                <input onChange={handleVendorChange} value={vendorFormData.rating}
                                    name="rating"
                                    type="text"
                                    className={`form-control alreadytext ${vendorFormik.touched.rating && vendorFormik.errors.rating ? 'is-invalid' : ''}`}
                                />
                                {vendorFormik.touched.rating && vendorFormik.errors.rating && (
                                    <div className="invalid-feedback">{vendorFormik.errors.rating}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Blacklisting/Approval Status *</label>
                                <select className={`form-control form-control ${vendorFormik.touched.rating && vendorFormik.errors.rating ? 'is-invalid' : ''}`} aria-label="Default select example" name="approvalStatus" onChange={handleVendorChange} value={vendorFormData.approvalStatus}>
                                    <option value='' hidden>Select approval status</option>
                                    {approvalStatus.map((item) => (
                                        <option value={item.value} key={item.value}>{item?.label}</option>
                                    ))}
                                </select>
                                {vendorFormik.touched.approvalStatus && vendorFormik.errors.approvalStatus && (
                                    <div className="invalid-feedback">{vendorFormik.errors.approvalStatus}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Remarks</label>
                                <input onChange={handleVendorChange} value={vendorFormData.remarks}
                                    name="remarks"
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>
                        <div className="col-md-6 mt-2">
                            <div className="mb-1">
                                <label className="form-label">Tax registration No.</label>
                                <input onChange={handleVendorChange} value={vendorFormData.taxRegistration}
                                    name='taxRegistration'
                                    type="text"
                                    className="form-control alreadytext"

                                />
                            </div>
                        </div>

                    </div>
                    <div className="d-flex justify-content-end" style={{ paddingRight: "50px" }}>

                        <button
                            type="submit"
                            className="btn yesbtn w-25">
                            Submit
                        </button>
                    </div>
                </form>
            </div>

        </section>
    )

}

export default AddVendor;